<template>
  <SensorIcon v-if="type === 'icon'"
    :disabled="disabled"
    :parent-disconnected="gatewayOrDeviceNotConnected"
    :state="state"
  />
  <span v-else-if="type === 'label'">
    {{ label }}
  </span>
</template>

<script setup lang="ts">
import { useSensorStatus } from '@/models/sensor/composables/use-sensor-status';
import { qx_eDeviceConnectionStatus_enum, qx_Sensor } from '@/graphql/types';
import { getSensorStatusIcon } from '@/constants/sensor';
import { computed } from 'vue';

const props = withDefaults(defineProps<{
  sensor: qx_Sensor,
  type?: 'icon' | 'label' // smartIconValidator()
}>(), {
  type: 'icon'
});

const sensor = computed(() => props.sensor)

const { gateway, connection } = useSensorStatus(sensor)

const disabled = computed(() => !sensor.value?.enabled || sensor.value.disabledByLicense)

const state = computed(() => sensor.value?.state)

const label = computed(() => {
  const status = getSensorStatusIcon(
    state.value,
    gatewayOrDeviceNotConnected.value,
    sensor.value?.disabledByLicense,
    sensor.value?.enabled
  );
  return status?.tooltip || '';
})

const gatewayOrDeviceNotConnected = computed(() => {
  return !(gateway.value?.connectionStatus && connection.value === qx_eDeviceConnectionStatus_enum.Connected);
});
</script>

